import Vue from 'vue'

import alerts from './alerts'

export const loadMixins = () => {
  Vue.mixin(alerts)
}
